import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/FaqPage/faqPage.js");
